var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductDescriptionOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3748 0.0883889C12.139 -0.029463 11.8616 -0.029463 11.6259 0.0883889L0.462811 5.66994C0.17917 5.81176 0 6.10166 0 6.41878V17.5819C0 17.899 0.17917 18.1889 0.462811 18.3307L11.6259 23.9123C11.8616 24.0301 12.139 24.0301 12.3748 23.9123L23.5378 18.3307C23.8215 18.1889 24.0007 17.899 24.0007 17.5819V6.41878C24.0007 6.10166 23.8215 5.81176 23.5378 5.66994L12.3748 0.0883889ZM1.67446 7.77397V17.0644L11.1631 21.8088V12.5183L1.67446 7.77397ZM12.8375 21.8088L22.3262 17.0644V7.77387L12.8375 12.5182V21.8088ZM21.2918 6.41903L12.0003 1.77329L2.70874 6.41908L12.0002 11.0648L21.2918 6.41903Z",
    fill: "#98B2C1",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6748 17.0649V7.77441L11.1634 12.5187V21.8092L1.6748 17.0649Z",
    fill: "#98B2C1",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3266 17.064L12.8379 21.8084V12.5178L22.3266 7.77344V17.064Z",
    fill: "#98B2C1",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionOutline);
export default __webpack_public_path__ + "static/media/product_description_outline.d0643f182a947a281fe682d0fb466f24.svg";
export { ForwardRef as ReactComponent };